// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hm","advertCardFooter__row":"c-a_hn","advertCardFooter__name":"c-a_ho","advertCardFooter__price":"c-a_hp","advertCardFooter__age":"c-a_hq"};